var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapEnd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#map-end_svg__filter0_d_77606_131420)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 2c6.627 0 12 5.373 12 12 0 5.652-3.907 10.391-9.168 11.664-.765.186-1.792 1.648-2.376 2.574a.551.551 0 01-.918.004c-.594-.929-1.636-2.401-2.37-2.578C14.908 24.39 11 19.652 11 14c0-6.627 5.373-12 12-12z",
    fill: "#F16622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.105 18.783c.352-.055.7-.107 1.043-.158v-3.932h.891v3.791c.48-.074.95-.15 1.406-.228v-4.36h-3.07v-.843h3.07v-1.828h-1.33a11.119 11.119 0 01-1.2 1.629 9.333 9.333 0 00-.692-.598c.883-.93 1.558-2.035 2.027-3.317l.89.235a17.3 17.3 0 01-.556 1.207h3.955v.844h-2.18v1.828h2.414v.843H21.36v1.489h2.215v.82H21.36v1.899c.825-.137 1.61-.274 2.356-.41-.024.367-.035.675-.035.925-2.125.36-4.227.73-6.305 1.113l-.27-.949zm7.207-8.777h4.02v6.95c0 .991-.438 1.495-1.313 1.51-.367.016-.8.016-1.3 0-.047-.359-.102-.69-.164-.995.406.062.773.093 1.101.093.508 0 .762-.25.762-.75v-5.941h-2.191v9.703h-.915v-10.57z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 37,
    r: 4,
    fill: "#F16622",
    stroke: "#fff",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "map-end_svg__filter0_d_77606_131420",
    x: 7,
    y: 0,
    width: 32,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.945098 0 0 0 0 0.4 0 0 0 0 0.133333 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77606_131420"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_77606_131420",
    result: "shape"
  })))));
}

export default SvgMapEnd;